// import React, { useEffect, useState } from "react";
// import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
// import Header from "./components/Header";
// import CarouselWrapper from "./components/CarouselWrapper";
// import Description from "./components/Descriptions";
// import TermsAndConditions from "./components/TermsAndConditions";
// import ChooseYourPlan from "./components/ChooseYourPlan";
// import MobileEntry from "./components/MobileEntry";
// import Footer from "./components/Footer";
// import "./App.css";
// import SuccessBlock from "./components/SuccessBlock";
// import {LanguageProvider, useLanguage} from "./context/LanguageContext";
// require("dotenv").config();
//
// function App() {
//
//   const { language } = useLanguage();
//
//   // useEffect(() => {
//   //   document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
//   // }, [language]);
//   //
//
//   const [pack, setPack] = useState(0);
//   const [showChooseYourPlan, setShowChooseYourPlan] = useState(true)
//
//   useEffect( ( )=> {
//     console.log("Is plan visible?",showChooseYourPlan)
//   }, [showChooseYourPlan])
//
//   const handleShowChooseYourPlan = () => {
//     setShowChooseYourPlan(!showChooseYourPlan)
//   }
//
//   return (
//       <LanguageProvider>
//     <BrowserRouter>
//       <Routes>
//         <Route path="mkt/:country/:operator/:merchant/:lp/:source/" element={
//           <div className="App container_inner">
//             <Header />
//             <CarouselWrapper className="" />
//             {showChooseYourPlan ? <ChooseYourPlan setPack={setPack} pack={pack}/> : <div/>}
//             <MobileEntry pack={pack} handleShowChooseYourPlan={handleShowChooseYourPlan}/>
//             <Description />
//             <TermsAndConditions pack={pack} />
//             <Footer />
//           </div>
//         }/>
//         <Route path="mkt/:country/:operator/:merchant/:lp/:source/success" element={<SuccessBlock/>}/>
//       </Routes>
//     </BrowserRouter>
// </LanguageProvider>
//   );
// }
//
// export default App;

//
//
// src/App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import CarouselWrapper from "./components/CarouselWrapper";
import Description from "./components/Descriptions";
import TermsAndConditions from "./components/TermsAndConditions";
import ChooseYourPlan from "./components/ChooseYourPlan";
import MobileEntry from "./components/MobileEntry";
import Footer from "./components/Footer";
import SuccessBlock from "./components/SuccessBlock";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import "./App.css";

const AppContent = () => {
  const { language } = useLanguage();
  const [pack, setPack] = useState(0);
  const [showChooseYourPlan, setShowChooseYourPlan] = useState(true)

  useEffect( ( )=> {
    console.log("Is plan visible?",showChooseYourPlan)
  }, [showChooseYourPlan])

  const handleShowChooseYourPlan = () => {
    setShowChooseYourPlan(!showChooseYourPlan)
  }
  // useEffect(() => {
  //   document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr'; // Set global direction
  // }, [language]);

  return (
      <div className="App container_inner">
        <Header />
         <CarouselWrapper className="" />
       {showChooseYourPlan ? <ChooseYourPlan setPack={setPack} pack={pack}/> : <div/>}
        <MobileEntry pack={pack} handleShowChooseYourPlan={handleShowChooseYourPlan}/>
        <Description />
        <TermsAndConditions pack={pack} />
        <Footer />
      </div>
  );
};

function App() {
  return (
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="mkt/:country/:operator/:merchant/:lp/:source/" element={<AppContent />} />
            <Route path="mkt/:country/:operator/:merchant/:lp/:source/success" element={<SuccessBlock />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
  );
}

export default App;
